import { Box, Container, Typography, Link } from '@mui/material';

const Footer = () => {
    const currentYear = new Date().getFullYear();
    return (
        <Box component="footer" sx={{ bgcolor: 'primary.main', py: 4, color: 'white' }}>
            <Container maxWidth="lg">
                <Typography variant="body1" align="center">
                    © {currentYear} Ethio Future Tutor. All Rights Reserved.
                </Typography>
                <Typography variant="body2" align="center" sx={{ mt: 1 }}>
                    <Link href="/policy_and_terms_of_use" color="inherit">
                        Privacy Policy
                    </Link>
                    {' | '}
                    <Link href="/policy_and_terms_of_use" color="inherit">
                        Terms of Service
                    </Link>
                </Typography>
            </Container>
        </Box>
    );
};

export default Footer;